import "relay-runtime";
const node = function() {
  var v0 = [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "requestBody"
    }
  ], v1 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "code",
    "storageKey": null
  }, v2 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }, v3 = [
    v1,
    v2
  ], v4 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, v5 = [
    v4,
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reason",
      "storageKey": null
    }
  ], v6 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "time",
    "storageKey": null
  }, v7 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "platform",
    "storageKey": null
  }, v8 = {
    "alias": null,
    "args": null,
    "concreteType": "v1_TravelServiceInformationSchedule",
    "kind": "LinkedField",
    "name": "schedule",
    "plural": false,
    "selections": [
      v6,
      v7
    ],
    "storageKey": null
  }, v9 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }, v10 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  }, v11 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "delayReason",
    "storageKey": null
  }, v12 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "cancellationReason",
    "storageKey": null
  }, v13 = {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "severity",
    "storageKey": null
  }, v14 = [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "requestBody",
          "variableName": "requestBody"
        }
      ],
      "concreteType": "v1_BulkTravelServiceInformationResponse",
      "kind": "LinkedField",
      "name": "v1_bulkTravelServiceInformation",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "v1_TravelServiceInformationResponse",
          "kind": "LinkedField",
          "name": "results",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "v1_TravelServiceInformationCarrier",
              "kind": "LinkedField",
              "name": "carrier",
              "plural": false,
              "selections": v3,
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "timetableId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "departureDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "customerOrigin",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "customerDestination",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "v1_TravelServiceInformationTransportMode",
              "kind": "LinkedField",
              "name": "transportMode",
              "plural": false,
              "selections": v3,
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "v1_TravelServiceInformationRealtime",
              "kind": "LinkedField",
              "name": "realTime",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isCancelled",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "v1_TravelServiceInformationDelayReason",
                  "kind": "LinkedField",
                  "name": "delayReasons",
                  "plural": true,
                  "selections": v5,
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "v1_TravelServiceInformationCancellationReason",
                  "kind": "LinkedField",
                  "name": "cancellationReasons",
                  "plural": true,
                  "selections": v5,
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "v1_TravelServiceInformationCallingPoint",
              "kind": "LinkedField",
              "name": "callingPoints",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "v1_TravelServiceInformationLocation",
                  "kind": "LinkedField",
                  "name": "location",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "genericCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "inventoryCode",
                      "storageKey": null
                    },
                    v2,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "shortName",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "callingType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "v1_TravelServiceInformationArrival",
                  "kind": "LinkedField",
                  "name": "arrival",
                  "plural": false,
                  "selections": [
                    v8,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "v1_TravelServiceInformationArrivalRealTime",
                      "kind": "LinkedField",
                      "name": "realTime",
                      "plural": false,
                      "selections": [
                        v9,
                        v10,
                        v6,
                        v7,
                        v11,
                        v12,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "hasArrived",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "arrivedEarlyAt",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "v1_TravelServiceInformationDeparture",
                  "kind": "LinkedField",
                  "name": "departure",
                  "plural": false,
                  "selections": [
                    v8,
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "v1_TravelServiceInformationDepartureRealTime",
                      "kind": "LinkedField",
                      "name": "realTime",
                      "plural": false,
                      "selections": [
                        v9,
                        v10,
                        v6,
                        v7,
                        v11,
                        v12,
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "hasDeparted",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "index",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "v1_TravelServiceInformationDisruption",
              "kind": "LinkedField",
              "name": "disruptions",
              "plural": true,
              "selections": [
                v4,
                v9,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastUpdated",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "trainlineUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "v1_TravelServiceInformationSource",
                  "kind": "LinkedField",
                  "name": "source",
                  "plural": false,
                  "selections": [
                    v2,
                    v4,
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "url",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "message",
                  "storageKey": null
                },
                v13,
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "category",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "v1_TravelServiceInformationError",
          "kind": "LinkedField",
          "name": "errors",
          "plural": true,
          "selections": [
            v1,
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "detail",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "v1_TravelServiceInformationErrorMetaData",
              "kind": "LinkedField",
              "name": "meta",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "service",
                  "storageKey": null
                },
                v13
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ];
  return {
    "fragment": {
      "argumentDefinitions": v0,
      "kind": "Fragment",
      "metadata": null,
      "name": "useBulkTravelServiceInformationV1Query",
      "selections": v14,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0,
      "kind": "Operation",
      "name": "useBulkTravelServiceInformationV1Query",
      "selections": v14
    },
    "params": {
      "id": "560a98ae08ea5a8ffcd90d296b1cf1245b2d5ff9",
      "metadata": {},
      "name": "useBulkTravelServiceInformationV1Query",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "49b55f3967431283b2688f6b1801b515";
var useBulkTravelServiceInformationV1Query_graphql_default = node;
export {
  useBulkTravelServiceInformationV1Query_graphql_default as default
};
